module.exports = __webpack_public_path__ + "static/img/big_icon.f99c1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/spacerBar/img/big_icon.png
// module id = lgwo
// module chunks = 157